import React, { useState, useEffect } from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { api } from "../../../utils/Api";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useParams } from "react-router-dom";

const animatedComponents = makeAnimated();

const initial_value = {
  services: [
    {
      selected_service: {},
      service_id: "",
      selected_event: {},
      event_id: "",
      quantity: "",
      notes: "",
      file_path: "",
      total_files: "",
      gst: false,
      amount: "",
      gst_amount: "",
      total_amount: "",
    },
  ],
};

export default function ModalAddService(props: any) {
  const [save_data, SetSaveData] = useState(initial_value);
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [is_open, SetIsOpen] = useState(false);
  const [id_value, SerIdValue] = useState(useParams());

  const [service_options, SetServiceOptions] = useState([]);
  const [event_options, SetEventOptions] = useState([]);
  const [gst_percent, SetGstPercent] = useState("");

  useEffect(() => {
    console.log("ModalAddService close data :", close_data);
  }, []);

  useEffect(() => {
    if (props.isOpen) {
      console.log("ModalAddService On Open :", props);
      SetIsOpen(props.isOpen);
      get_init();
    }
  }, [props.isOpen]);

  const Switch = ({ isOn, handleToggle, onColor, index }) => {
    return (
      <>
        <input
          checked={isOn}
          onChange={handleToggle}
          className="react-switch-checkbox"
          id={`react-switch-` + index}
          type="checkbox"
        />
        <label
          style={{ background: isOn && onColor }}
          className="react-switch-label"
          htmlFor={`react-switch-` + index}
        >
          <span className={`react-switch-button`} />
        </label>
      </>
    );
  };

  async function get_init() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        company_id: props.data.company_id,
      },
    };
    let data_res = await api("/outlet/create_order_init_v2", pass_data);
    console.log("create_order_init_v2 response :", data_res.response);

    if (data_res.response.hasOwnProperty("services")) {
      let option_data = [];
      Object.keys(data_res.response.services).map((key, index) => {
        let push_data = {};
        if (key == "type_1") {
          push_data.label = "Image";
        } else if (key == "type_2") {
          push_data.label = "Video";
        } else {
          push_data.label = "Audio";
        }
        push_data.options = data_res.response.services[key];
        option_data.push(push_data);
      });
      console.log("Option Data :", option_data);
      SetServiceOptions(option_data);
    }

    if (data_res.response.hasOwnProperty("events")) {
      SetEventOptions(data_res.response.events);
    }
    if (data_res.response.hasOwnProperty("settings")) {
      SetGstPercent(data_res.response.settings.gst_percent);
    }
  }

  async function add_services() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        // order_id: props.data.order_id,
      },
      post: {
        event_id: props.data.event_id,
        services: {
          service_id: save_data.services[0].selected_service.id,
          quantity: save_data.services[0].entered_quantity,
          notes: save_data.services[0].notes,
          total_files: save_data.services[0].total_files,
          file_path: save_data.services[0].file_path,
        },
      },
    };
    let data_res = await api("/outlet/add_order_services", pass_data);
    console.log("Add Service res :", data_res);
    console.log("Add Service :", save_data);
    // let item = close_data;
    // item.action = "close";
    // item.data = save_data;
    // SetCloseData(item);
    SetSaveData(initial_value);
    console.log("after Add Service :", save_data);
  }

  //////

  function add_new_service() {
    // if(save_data.services)
    let add_data = {
      selected_service: {},
      service_id: "",
      selected_event: {},
      event_id: "",
      quantity: "",
      notes: "",
      file_path: "",
      total_files: "",
      gst: false,
      amount: "",
      gst_amount: "",
      total_amount: "",
    };
    SetSaveData((prevValue) => {
      prevValue.services.push(add_data);
      return { ...prevValue };
    });
  }

  function remove_service(service_index: any) {
    SetSaveData((prevValue) => {
      prevValue.services.splice(service_index, 1);
      return { ...prevValue };
    });
  }

  function service_on_change(event: any, index: any) {
    SetSaveData((prevValue) => {
      prevValue.services[index].selected_service = event;
      prevValue.services[index].service_id = event.id;
      // prevValue.services[index].gst_amount = 0;
      // prevValue.services[index].total_amount = 0;
      // prevValue.services[index].amount = 0;
      // prevValue.services[index].quantity = "";

      return { ...prevValue };
    });
  }

  function event_on_change(event: any, index: any) {
    SetSaveData((prevValue) => {
      prevValue.services[index].selected_event = event;
      prevValue.services[index].event_id = event.id;
      return { ...prevValue };
    });
  }

  function quantity_on_change(event: any, index: any) {
    SetSaveData((prevValue) => {
      prevValue.services[index].quantity = event.target.value;
      return { ...prevValue };
    });
  }

  function notes_on_change(e: any, service_index: any) {
    SetSaveData((prevValue) => {
      prevValue.services[service_index].notes = e.target.value;
      return { ...prevValue };
    });
  }

  function file_path_on_change(e: any, service_index: any) {
    SetSaveData((prevValue) => {
      prevValue.services[service_index].file_path = e.target.value;
      return { ...prevValue };
    });
  }

  function total_files_on_change(e: any, service_index: any) {
    SetSaveData((prevValue) => {
      prevValue.services[service_index].total_files = e.target.value;
      return { ...prevValue };
    });
  }

  async function update_service() {
    let service_pass_data = [];
    save_data.services.map((service_item) => {
      let sample_data = {
        service_id: service_item.service_id,
        event_id: service_item.event_id,
        quantity: service_item.quantity,
        notes: service_item.notes,
        total_files: service_item.total_files,
        file_path: service_item.file_path,
        gst: service_item.gst,
        amount: service_item.amount,
        gst_amount: service_item.gst_amount,
        total_amount: service_item.total_amount,
      };
      service_pass_data.push(sample_data);
    });
    let post_value = {
      services: service_pass_data,
    };
    console.log("post_value :", post_value);
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: props.data.order_id,
      },
      post: post_value,
    };

    console.log("pass value :", pass_data);
    let data_res = await api("/outlet/add_order_services_v2", pass_data);
    console.log("add_order_services_v2 response :", data_res.response);
    if (data_res.response.hasOwnProperty("order_services")) {
      let item = close_data;
      item.action = "save";
      item.service_data = data_res.response.order_services;
      SetCloseData(item);
      SetIsOpen(false);
      SetSaveData({
        services: [
          {
            selected_service: {},
            service_id: "",
            selected_event: {},
            event_id: "",
            quantity: "",
            notes: "",
            file_path: "",
            total_files: "",
            gst: false,
            amount: "",
            gst_amount: "",
            total_amount: "",
          },
        ],
      });
      props.close(close_data);
    }
  }

  return (
    <div>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={is_open}
        title="Add Service"
        onRequestClose={() => {
          console.log("close");
          let item = close_data;
          item.action = "close";
          SetCloseData(item);
          SetIsOpen(false);
          SetSaveData({
            services: [
              {
                selected_service: {},
                service_id: "",
                selected_event: {},
                event_id: "",
                quantity: "",
                notes: "",
                file_path: "",
                total_files: "",
                gst: false,
                amount: "",
                gst_amount: "",
                total_amount: "",
              },
            ],
          });
          props.close(close_data);
        }}
        from="right"
        width="500px"
      >
        <div className="pt-0 pe-0">
          <div className="">
            <h5>Service</h5>
          </div>
          {save_data.services.map((service_item, service_item_index) => (
            <div className="py-3 border-bottom" key={service_item_index}>
              <div
                className="ms-auto p-0 cursor text-end"
                onClick={() => {
                  console.log("close");
                  remove_service(service_item_index);
                }}
              >
                <i className="fas fa-times"></i>
              </div>
              <div className="row pt-3 align-items-center">
                {/* Select Service */}
                <div className="col-md-6 mb-2">
                  <label className="form-label">Select Service</label>
                  <Select
                    components={animatedComponents}
                    className="basic-multi-select"
                    classNamePrefix="select Service"
                    placeholder="Select Service"
                    value={service_item.selected_service}
                    options={service_options}
                    onChange={(e) => {
                      console.log("service on change :", e);
                      service_on_change(e, service_item_index);
                    }}
                  />
                </div>
                {/* Select Event */}
                <div className="col-md-6 mb-2">
                  <label className="form-label">Select Event</label>
                  <Select
                    components={animatedComponents}
                    className="basic-multi-select"
                    classNamePrefix="select Service"
                    placeholder="Select Service"
                    value={service_item.selected_event}
                    options={event_options}
                    onChange={(e) => {
                      console.log("event on change :", e);
                      event_on_change(e, service_item_index);
                    }}
                  />
                </div>
                {/* Quantity */}
                <div className="col-md-6 col-8 mb-2">
                  <label className="form-label">
                    Quantity / Duration <small>In minute</small>{" "}
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    required
                    value={service_item.quantity}
                    onChange={(e) => {
                      // quantity_on_change(e, service_item_index);
                      SetSaveData((prevValue) => {
                        let gst_amount_value,
                          total_amount_value,
                          entered_amount,
                          entered_quantity;
                        let price =
                          prevValue.services[service_item_index]
                            .selected_service.price;
                        let price_quantity =
                          prevValue.services[service_item_index]
                            .selected_service.price_quantity;
                        let service_price = parseFloat(price / price_quantity);
                        entered_quantity = e.target.value;
                        entered_amount = parseFloat(
                          service_price * entered_quantity
                        );
                        gst_amount_value = (gst_percent / 100) * entered_amount;

                        if (prevValue.services[service_item_index].gst) {
                          total_amount_value =
                            parseFloat(gst_amount_value, 2) +
                            parseFloat(entered_amount, 2);
                        } else {
                          total_amount_value = entered_amount;
                        }
                        prevValue.services[service_item_index].quantity =
                          entered_quantity;
                        prevValue.services[service_item_index].amount =
                          entered_amount.toFixed(2);
                        prevValue.services[service_item_index].gst_amount =
                          gst_amount_value.toFixed(2);
                        prevValue.services[service_item_index].total_amount =
                          total_amount_value.toFixed(2);
                        return { ...prevValue };
                      });
                    }}
                  />
                </div>
                {/* GST */}
                <div className="col-md-3 col-4 mb-2 ps-0 ps-md-2">
                  <label className="form-label d-flex cursor">
                    <Switch
                      isOn={service_item.gst}
                      onColor="#06D6A0"
                      index={service_item_index}
                      handleToggle={(e) => {
                        SetSaveData((prevValue) => {
                          prevValue.services[service_item_index].gst =
                            !prevValue.services[service_item_index].gst;
                          let gst_amount_value,
                            total_amount_value,
                            entered_amount;
                          if (
                            prevValue.services[service_item_index].amount != ""
                          ) {
                            entered_amount =
                              prevValue.services[service_item_index].amount;
                          } else {
                            entered_amount = 0;
                          }
                          gst_amount_value =
                            (gst_percent / 100) * entered_amount;
                          if (prevValue.services[service_item_index].gst) {
                            total_amount_value =
                              parseFloat(gst_amount_value) +
                              parseFloat(entered_amount);
                          } else {
                            total_amount_value = parseFloat(entered_amount);
                          }
                          prevValue.services[service_item_index].gst_amount =
                            gst_amount_value.toFixed(2);
                          prevValue.services[service_item_index].total_amount =
                            total_amount_value.toFixed(2);
                          return { ...prevValue };
                        });
                      }}
                    />
                    <span className="ps-2">GST</span>
                  </label>
                </div>
                {/* Amount */}
                <div className="col-md-6 col-6 mb-2">
                  <label className="form-label">Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    required
                    value={service_item.amount}
                    onChange={(e) => {
                      SetSaveData((prevValue) => {
                        let gst_amount_value,
                          total_amount_value,
                          entered_amount;
                        entered_amount = parseFloat(e.target.value);
                        gst_amount_value = (gst_percent / 100) * entered_amount;

                        if (prevValue.services[service_item_index].gst) {
                          total_amount_value =
                            parseFloat(gst_amount_value) +
                            parseFloat(entered_amount);
                        } else {
                          total_amount_value = parseFloat(entered_amount);
                        }
                        console.log(
                          "before entered_amount:",
                          typeof entered_amount
                        );
                        prevValue.services[service_item_index].amount =
                          entered_amount.toFixed(2);
                        prevValue.services[service_item_index].gst_amount =
                          gst_amount_value.toFixed(2);
                        prevValue.services[service_item_index].total_amount =
                          total_amount_value.toFixed(2);
                        return { ...prevValue };
                      });
                    }}
                  />
                </div>
                {/* gst amount */}
                {service_item.gst ? (
                  <div className="col-md-6 col-6 mb-2">
                    <label className="form-label">GST Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      disabled={true}
                      value={service_item.gst_amount}
                    />
                  </div>
                ) : null}

                {/* total amount */}
                <div className="col-md-6 col-6 mb-2">
                  <label className="form-label">Total Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    disabled={true}
                    value={service_item.total_amount}
                    onChange={(e) => {
                      console.log("e :", e.target.value);
                    }}
                  />
                </div>
              </div>

              {service_item.service_id != "" && service_item.quantity != "" ? (
                <div className="row">
                  <div className="col-12 mt-3">
                    <label className="form-label">Notes</label>
                    <textarea
                      placeholder="Enter some notes"
                      className="form-control"
                      rows={1}
                      value={service_item.notes}
                      onChange={(e) => {
                        notes_on_change(e, service_item_index);
                      }}
                    ></textarea>
                  </div>

                  <div className="col-6 mt-3">
                    <label className="form-label">File path</label>
                    <input
                      type="text"
                      className="form-control"
                      value={service_item.file_path}
                      onChange={(e) => {
                        file_path_on_change(e, service_item_index);
                      }}
                    />
                  </div>

                  <div className="col-6 mt-3">
                    <label className="form-label">Total Files</label>
                    <input
                      type="text"
                      className="form-control"
                      value={service_item.total_files}
                      onChange={(e) => {
                        total_files_on_change(e, service_item_index);
                      }}
                    />
                  </div>
                </div>
              ) : null}
            </div>
          ))}
          <div className="row">
            <div className="col-6">
              <button
                className="btn btn-light-outline btn-sm mt-3"
                onClick={() => {
                  add_new_service();
                }}
              >
                Add New Service
              </button>
            </div>
            <div className="col-6 text-end">
              <button
                className="btn btn-light-outline btn-sm mt-3 "
                onClick={() => {
                  console.log("Update service save data :", save_data);
                  update_service();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </SlidingPane>
    </div>
  );
}
